export class ValidationConstants {

    static readonly FILE_SIZE:string="Upto 10MB file only allowed for"
    static readonly FILE_TYPE:string="Only Specified files are allowed to upload"
    static readonly VALIDATION_MSG={
        name:'Please enter First Name',
        email:'Please enter Email Address',
        title:'Please enter Title',
        subject:'Please enter Subject',
        date:'Please select a Contact Date',
        comment:'Please enter a Comment',
        comment_maxlength:'Comments cannot be more than 3000 characters',

        phone:'Please enter a valid Phone Number',
        password:'Please enter a valid Password',
        confirmPassword:'Please enter a valid Confirm Password',

        minLength:'Please enter minimum of 3 characters',

        validEmail:'Sorry, you have entered an invalid Email Address',

        // Login specific validation messages
        emailPhoneEmpty: 'Please enter Email/Phone',
        emailPhoneInvalid: 'Please enter a valid Email/Phone',
        passwordEmpty: 'Please enter Password',
        passwordInvalid: 'Please enter a valid Password',

        titleSpecialChar:'Please enter a valid Title (Allowed only  A-Z, a-z, 0-9, Dot, Space, Apostrophe , Exclamation, Hyphen)',
        subjectSpecialChar:'Please enter a valid Subject (Allowed only  A-Z, a-z, 0-9, Dot, Space, Apostrophe , Exclamation, Hyphen)',
        sourceSpecialChar:'Please enter a valid Title (Allowed only  A-Z, a-z, 0-9, Dot, Space, Hyphen)',
        taskTitleSpecialChar:'Please enter a valid Title (Allowed only  A-Z, a-z, 0-9, /,comma, Dot, Space, Apostrophe , Exclamation, Hyphen)',
        companyTitleSpecialChar:'Please enter a valid Company Title (allowed Only  A-Z, a-z, 0-9, Dot, Space, Apostrophe, Exclamation, Hyphen, Atrate, Colon, Forward slash)',
        companyNameSpecialChar:'Please enter a valid Company Name (allowed only A-Z, a-z, DOT, Comma, Apostrophe, Hyphen, Space, Atrate, Colon, Forward Slash)',
        nameSpecialChar:'Please enter a valid First Name (allowed only A-Z, a-z, 0-9, DOT, Comma, Apostrophe, Hyphen, Space)',
        lastNameSpecialChar:'Please enter a valid Last Name (allowed only  A-Z, a-z, Comma, Dot, Space, Apostrophe, Hyphen)',
        percentage:'Percentage cannot be more than 100'
    }




    // === PATTERN VALIDATIONS ===
  
    /** Email pattern (standard) */
    // static readonly EMAIL_PATTERN: RegExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    /** Email pattern (robust and performant) */
    static readonly EMAIL_PATTERN: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    /** Phone number pattern (international + extensions) */
    static readonly PHONE_PATTERN: RegExp = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

    /** Website pattern (URL) */
    static readonly WEBSITE_PATTERN: RegExp = /^((https?|ftp|smtp):\/\/)?(www\.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
  
    /** Only letters (no numbers/symbols) */
    static readonly ONLY_LETTERS_PATTERN: RegExp = /^[A-Za-z\s]+$/;
  
    /** Alphanumeric with spaces */
    static readonly ALPHANUMERIC_PATTERN: RegExp = /^[A-Za-z0-9\s]+$/;

     /** Alpha-numeric with underscores */
    static readonly ALPHA_NUMERIC_PATTERN: RegExp = /^[a-zA-Z 0-9_]*$/;
  
    /** Password pattern: at least 1 uppercase, 1 number, 1 special char, 8–16 length */
    static readonly PASSWORD_PATTERN: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,16}$/;

    /** Number not starting with zero */
    static readonly NUMBER_ZERO_PATTERN: RegExp = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/i;

    /** Name pattern (letters, numbers, common punctuation) */
    static readonly NAME_PATTERN: RegExp = /^[a-z0-9 ,.'-]+$/i;

    /** Name + slash */
    static readonly NAME_SLASH_PATTERN: RegExp = /^[a-z0-9 ,.'/-]+$/i;

    /** Name + slash + underscore */
    static readonly NAME_SLASH_UNDERSCORE_PATTERN: RegExp = /^[a-z0-9 ,.'/_-]+$/i;

    /** Title pattern */
    static readonly TITLE_PATTERN: RegExp = /^[a-z0-9 !.'-]+$/i;

    /** Source pattern */
    static readonly SOURCE_PATTERN: RegExp = /^[a-z0-9 .-]+$/i;

    /** Filter pattern */
    static readonly FILTER_PATTERN: RegExp = /^[a-z0-9 !-_]+$/i;

    /** Task title pattern */
    static readonly TASK_TITLE_PATTERN: RegExp = /^[a-z0-9 /,!.'-]+$/i;

    /** Company pattern */
    static readonly COMPANY_PATTERN: RegExp = /^[a-z0-9 @/:!.'-]+$/i;

    /** Port (only numbers) */
    static readonly PORT_PATTERN: RegExp = /^[0-9]*$/;

    /** Percentage (0–100 with up to 2 decimals) */
    static readonly PERCENTAGE_PATTERN: RegExp = /^(\d{0,2}(\.\d{1,2})?|100(\.00?)?)$/;






  
    // === LENGTH CONSTANTS ===
  
    static readonly MIN_LENGTH_TEXT = 3; 
    static readonly MAX_LENGTH_TEXT = 50;

    static readonly MIN_LENGTH_DESCRIPTION = 5;
    static readonly MAX_LENGTH_DESCRIPTION = 250;

    static readonly MIN_LENGTH_PASSWORD = 8;
    static readonly MAX_LENGTH_PASSWORD = 16;

    static readonly PHONE_LENGTH = 10;



    
  
    // === NUMERIC CONSTANTS ===
  
    /** Min & Max value for numeric inputs (example) */
    static readonly MAX_NUMBER_VALUE = 9999;
    static readonly MIN_NUMBER_VALUE = 1;

    /**
     * Validator for password with specific requirements
     */
    static passwordValidator() {
        return (control: import('@angular/forms').AbstractControl): import('@angular/forms').ValidationErrors | null => {
            const value = control.value;
            if (!value || typeof value !== 'string') return null;
            
            const trimmedValue = value.trim();
            if (!trimmedValue) return null;
            
            // Check if password meets the pattern requirements
            if (!ValidationConstants.PASSWORD_PATTERN.test(trimmedValue)) {
                return { invalidFormat: true };
            }
            
            return null;
        };
    }

    /**
     * Validator for email or phone number (10 digits)
     */
    static emailOrPhoneValidator() {
        return (control: import('@angular/forms').AbstractControl): import('@angular/forms').ValidationErrors | null => {
            const value = control.value;
            // if (!value) return null;
            // const isEmail = ValidationConstants.EMAIL_PATTERN.test(value);
            // const isPhone = /^\d{10}$/.test(value);
            // return !isEmail && !isPhone ? { invalidFormat: true } : null;
            if (!value || typeof value !== 'string') return null;
            
            // Trim the value to handle whitespace
            const trimmedValue = value.trim();
            if (!trimmedValue) return null;
            
            // Add length check to prevent excessive processing
            if (trimmedValue.length > 254) { // RFC 5321 limit
                return { invalidFormat: true };
            }
            
            // Early exit for obviously invalid formats
            if (trimmedValue.length < 5) { // Minimum length for valid email/phone
                return { invalidFormat: true };
            }
            
            // Check if it's a phone number first (faster check)
            if (/^\d{10}$/.test(trimmedValue)) {
                return null;
            }
            
            // Check if it's an email
            if (ValidationConstants.EMAIL_PATTERN.test(trimmedValue)) {
                return null;
            }
            
            return { invalidFormat: true };
        };
    }

    /**
     * Returns error message for email/phone field
     */
    static getEmailOrPhoneErrorMessage(control: import('@angular/forms').AbstractControl): string {
        if (!control?.errors || !control.touched) return '';
        if (control.errors['required']) return ValidationConstants.VALIDATION_MSG.emailPhoneEmpty;
        if (control.errors['invalidFormat']) return ValidationConstants.VALIDATION_MSG.emailPhoneInvalid;
        return '';
    }

    /**
     * Returns error message for password field
     */
    static getPasswordErrorMessage(control: import('@angular/forms').AbstractControl): string {
        if (!control?.errors || !control.touched) return '';
        if (control.errors['required']) return ValidationConstants.VALIDATION_MSG.passwordEmpty;
        if (control.errors['invalidFormat']) return ValidationConstants.VALIDATION_MSG.passwordInvalid;
        return '';
    }
}
  